  import { useEffect, useState } from "react";
  import {
    SmartAlert,
    SmartLoaderInterface,
    SmartSoftButton,
    SmartTable,
    SmartTableNewInterface,
  } from "sds_react_toolkit";
  import { SECTOR_URLS } from "../../api/ManageUrls";
  import { useSiteContext } from "../../contexts/SiteProvider";
  import { showAlertAutoClose } from "../../services/notifyService";
  import { get, post } from "../../services/smartApiService";
  import SectorForm from "./SectorForm";

  const SectorTable = () => {
    const [tabData, setTabData] = useState<any[]>([]);

    const { openModal, setTitle } = useSiteContext();

    useEffect(() => {
      setTitle("Sectors Management");
      loadTableData();
    }, []);

    const loadTableData = () => {
      const subscription = get(SECTOR_URLS.GET_ALL).subscribe((response) => {
        setTabData(response.data || []);
      });
      return () => subscription.unsubscribe();
    };

    const deleteData = (id: number) => {
      const subscription = post(`${SECTOR_URLS.DELETE}${id}`, {}).subscribe(() => {
        showAlertAutoClose("Sector deleted successfully", "success");
        loadTableData();
      });
      return () => subscription.unsubscribe();
    };

    const openDeleteModal = (row: any) => {
      const alertProps: SmartLoaderInterface.SmartAlertInterface = {
        title: (
          <span className="has-text-danger">
            <i className="fa fa-exclamation-triangle"></i> Confirm Deletion
          </span>
        ),
        alertFunction: (option: any) => {
          if (option === "yes") {
            deleteData(row.id);
            SmartAlert.hide();
          }
        },
        content: (
          <p>
            Do you want to delete sector <strong>{row.name}</strong>? <br />
            <strong>This action cannot be undone.</strong>
          </p>
        ),
        className: "custom-alert",
      };
      SmartAlert.show(alertProps);
    };

const openSectorForm = (data?: any) => {
  const options = {
    title: data ? "Edit Sector" : "Add New Sector",
    content: <SectorForm loadTableData={loadTableData} data={data} />,
    className: "sd-efl-modal",
    closeBody: false,
    width: 80,
  };
  openModal(options);
};


    const viewEditForm = (id: number) => {
      const subscription = get(`${SECTOR_URLS.GET_ONE}${id}`).subscribe(
        (response: any) => {
          openSectorForm(response.data || null);
        }
      );
      return () => subscription.unsubscribe();
    };

    const buttons = [
      {
        label: "",
        type: "icon",
        leftIcon: "fa-pencil-square",
        classList: ["smart-hims-table-edit-icon"],
        onClick: (data: any) => viewEditForm(data.id),
      },
      {
        label: "",
        type: "icon",
        leftIcon: "fa-trash",
        classList: ["smart-hims-table-delete-icon"],
        onClick: (data: any) => openDeleteModal(data),
      },
    ];

    const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
      { title: "S.NO", index: "s_no", type: "sno", width: "5" },
      {
        title: "Name",
        index: "name",
        isSortable: true,
        isFilterable: true,
        width: "20",
      },
      {
        title: "Description",
        index: "description",
        width: "50",
        isFilterable: true,
      },
      // {
      //   title: "Companies",
      //   index: "company_count",
      //   width: "10",
      //   isSortable: true,
      //   type: "details",
      //   valueFunction: (row: any) => (
      //     <span className="tag is-info">
      //       {row.company_count || 0} Companies
      //     </span>
      //   ),
      // },
      // {
      //   title: "Status",
      //   index: "is_active",
      //   width: "10",
      //   isFilterable: true,
      //   type: "details",
      //   valueFunction: (row: any) => (
      //     <span
      //       className={`tag ${row.is_active ? "is-success" : "is-danger"}`}
      //     >
      //       {row.is_active ? "Active" : "Inactive"}
      //     </span>
      //   ),
      // },
      {
        title: "Action",
        index: "action",
        type: "buttons",
        buttons,
        width: "10",
      },
    ];

    const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
      {
        type: "CUSTOM",
        widthClass: "is-6",
        custom: <p className="is-size-4 has-text-weight-bold">Sectors</p>,
      },
      {
        type: "SEARCH",
        widthClass: "is-4",
        align: "JUSTIFY",
      },
      {
        type: "BUTTONS",
        widthClass: "is-1",
        align: "RIGHT",
        buttons: [
          {
            type: "REFRESH",
            action: loadTableData,
          },
        ],
      },
      {
        type: "CUSTOM",
        widthClass: "is-1",
        align: "RIGHT",
        custom: (
       <SmartSoftButton
  label="Add"
  onClick={() => openSectorForm()}
  leftIcon="fa fa-plus"
  classList={["smart-action-button"]}
/>

        ),
      },
    ];

    return (
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={tableTop}
          tableProps={{
            className: "is-hoverable is-striped dsc-table-container",
            isResponsive: true,
            searchPlaceHolder: "Search sectors",
          }}
          paginationProps={{
            pageSize: 10,
          }}
        />
      </div>
    );
  };

  export default SectorTable;
